import { BasketActions } from "./actions";

const initialState = {
    basket: [],
    favorites: [],
    downloads: []
}

export const basketReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case BasketActions.ADD_TO_BASKET:
            return {
                ...state,
                basket: [...state.basket, action.payload]
            }
        case BasketActions.REMOVE_FROM_BASKET:
            return {
                ...state,
                basket: state.basket.filter((item: any) => item.id !== action.payload.id)
            }
        case BasketActions.ADD_TO_FAVORITES:
            return {
                ...state,
                favorites: [...state.favorites, action.payload]
            }
        case BasketActions.REMOVE_FROM_FAVORITES:
            return {
                ...state,
                favorites: state.favorites.filter((item: any) => item.id !== action.payload.id)
            }
        case BasketActions.ADD_TO_DOWNLOADS:
            return {
                ...state,
                downloads: [...state.downloads, action.payload]
            }
        case BasketActions.REMOVE_FROM_DOWNLOADS:
            return {
                ...state,
                downloads: state.downloads.filter((item: any) => item?.id !== action.payload.id)
            }
        case BasketActions.TOGGLE_FAVORITE:
            return {
                ...state,
                favorites: state.favorites.some((item: any) => item.id === action.payload.id) ?
                    state.favorites.filter((item: any) => item.id !== action.payload.id) :
                    [...state.favorites, action.payload]
            }
        case BasketActions.DOWNLOAD_REQUEST_SUCCESS:
            return {
                ...state,
                code: action.payload.code,
                result: action.payload.result,
                success: action.payload.success,
                expected: action.payload.expected,
                error: null,
            }
        case BasketActions.DOWNLOAD_REQUEST_ERROR:
            return {
                ...state,
                error: action.payload,
                code: null,
            }
        case BasketActions.CLEAR_DOWNLOAD_REQUEST_ERROR:
            return {
                ...state,
                error: null,
            }
        case BasketActions.CLEAR_BASKET:
            return {
                ...state,
                basket: []
            }
        case BasketActions.CLEAR_STATUS_CODE:
            return {
                ...state,
                code: null,
                error: null,
            }
        case BasketActions.CHECK_DO_AVAILABILITY_SUCCESS:
            return {
                ...state,
                doAvailability: action.payload,
            }
        case BasketActions.CHECK_DO_AVAILABILITY_ERROR:
            return {
                ...state,
                doAvailability: null,
                error: action.payload,
            }
        default:
            return state;
    }
}